module.exports = __webpack_public_path__ + "img/eye.a18f1b79.svg";